import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import GetEBookButton from './GetEBookButton';

const playfair = "'Playfair Display', serif";
const crimson = "'Crimson Text', serif";

const IntroducingParentalGuide = () => (
    <Box
        textAlign="center"
        sx={{ position: 'relative', overflow: 'visible' }}
    >
        {/* Main Title */}
        <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
                fontWeight: 400,
                color: 'text.primary',
                position: 'relative',
                zIndex: 5,
                pt: { xs: 2, md: 4 },
            }}
        >
            Happy US: A Parental Guide For The Positive Psychology Kids' Program (PPKP)
        </Typography>

        {/* Subtitle */}
        <Typography
            variant="h5"
            color="text.secondary"
            sx={{
                fontWeight: 400,
                fontSize: { xs: 18, md: 24 },
                color: 'text.secondary',
                position: 'relative',
                zIndex: 5,
                mb: { xs: 2, md: 4 },
                paddingBottom: 5
            }}
            gutterBottom
        >
            Fundamentals For Every Happy Family
        </Typography>

        {/* Bonus Splash-Zone Section */}
        <Box
            mt={0}
            sx={{
                bgcolor: 'custom.red',
                position: 'relative',
                overflow: 'visible',
                borderRadius: 3,
                py: { xs: 8, md: 12 },
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {/* Absolutely positioned image with margin on top */}
            <Box
                component="img"
                src="/assets/cyj-ebook-chapter-bundle.png"
                alt="Craft Your Journey eBook"
                loading="lazy"
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    top: { xs: '-18%', md: '-25%' },
                    width: { xs: 280, sm: 380, md: 560 },
                    maxWidth: '90%',
                    zIndex: 10,
                    pointerEvents: 'none',
                    display: 'block',
                    mt: 4, // margin on top of the image
                    paddingTop: 5
                }}
            />

            <Grid
                container
                spacing={0}
                justifyContent="center"
                alignItems="center"

            >
                {/* Center the bonus splash content */}
                <Grid
                    item
                    xs={12}
                    sx={{
                        zIndex: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        pt: 10,
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontFamily: playfair,
                            fontWeight: 400,
                            fontSize: { xs: 28, md: 43 },
                            color: 'text.primary',
                        }}
                    >
                        <strong>The Bonus</strong>
                    </Typography>

                    <Typography
                        variant="h4"
                        sx={{
                            fontFamily: playfair,
                            fontWeight: 400,
                            fontSize: { xs: 28, md: 43 },
                            color: 'text.primary',
                            mb: 2,
                        }}
                    >
                        <strong>Splash-Zone:</strong>
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            fontFamily: crimson,
                            fontWeight: 400,
                            fontSize: { xs: 16, md: 18 },
                            color: 'text.secondary',
                            textAlign: 'center',
                            maxWidth: 600,
                            mb: 4,
                        }}
                    >
                        When you get your <em>Happy US</em> eBook today, you’ll also receive <strong>5 beautifully designed printable tools</strong> that make emotional learning even easier (and more joyful!) for your kids.
                    </Typography>
                    <GetEBookButton />
                </Grid>
            </Grid>
        </Box>
    </Box>
);

export default IntroducingParentalGuide;
